<template>
  <ModalDefault modal_id="filesTicketModal"
                header="y"
                size="modal-lg modal-dialog-scrollable"
                style_header=""
                :modal_header="getTranslations('expression_924')"
                :footer="chat.files.length > 0"
                icon="bx bx-paperclip mr-1">
    <div class="px-3 py-2" slot="body">
      <div class="row pb-1" style="max-height: 480px;">
        <div v-if="chat.files.length < 3" class="col-12 px-2">
          <div class="bg-light border cursor_pointer py-3" style="display: flex; justify-content: center; align-items: center;">
            <input type="file"
                   @change.prevent="loadFile"
                   id="fileHandlerChat"
                   multiple="multiple">
            <div class="d-block pt-3 pb-4 text-center">
              <div>
                <i class="bx bx-upload bx-md title-color"></i>
              </div>
              <div>
                <div>
                  <span class="pb-2 title-color">{{ getTranslations('expression_704') }}</span>
                </div>
                <div class="pt-2">
                  <small class="pt-2">
                    {{ getTranslations('expression_705') }}
                    <br>
                    {{ getTranslations('expression_634') }}
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-for="(file, index) in chat.files" :key="index" class="col-12 px-2 mx-50 pt-4">
          <div class="col-12 d-flex shadow-sm p-0">
            <div class="">
              <img v-if="['image/png', 'image/jpeg', 'image/jpg', 'image/webp'].includes(file.mimetype)"
                   :src="file.file"
                   style="max-height: 120px;
                              min-height: 120px;
                              min-width: 120px;
                              max-width: 120px;"
                   class="cursor-default">

              <div style="max-height: 120px;
                              min-height: 120px;
                              min-width: 120px;
                              max-width: 120px;
                              display: flex;
                              align-items: center;
                              justify-content: center;"
                   class="bg-light"
                   v-if="['application/pdf'].includes(file.mimetype)">
                <i class="bx bxs-file-pdf bx-md"></i>
              </div>

              <div style="max-height: 120px;
                              min-height: 120px;
                              min-width: 120px;
                              max-width: 120px;
                              display: flex;
                              align-items: center;
                              justify-content: center;"
                   class="bg-light"
                   v-if="['application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/msword'].includes(file.mimetype)">
                <i class="fa fa-file-word bx-md"></i>
              </div>

              <div style="max-height: 120px;
                              min-height: 120px;
                              min-width: 120px;
                              max-width: 120px;
                              display: flex;
                              align-items: center;
                              justify-content: center;"
                   class="bg-light"
                   v-if="['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'].includes(file.mimetype)">
                <i class="fa fa-file-excel bx-md"></i>
              </div>

              <div style="max-height: 120px;
                              min-height: 120px;
                              min-width: 120px;
                              max-width: 120px;
                              display: flex;
                              align-items: center;
                              justify-content: center;"
                   class="bg-light"
                   v-if="['video/mpeg', 'video/mp4'].includes(file.mimetype)">
                <video width="120" height="120" controls>
                  <source :src="file.file" type="video/mp4">
                </video>
                <!--                    <i class="bx bx-camera-movie bx-md"></i>-->
              </div>
            </div>
            <div class="py-2 px-3 w-100">
              <div class="d-flex justify-content-between pt-2">
                <div class="ellipsis p-0 m-0">
                  <small>{{ file.filename | truncate(15) }}</small>
                </div>
                <div @click.prevent="chat.files.splice(index, 1)" class="cursor_pointer">
                  <i class="bx bx-x bx-sm"></i>
                </div>
              </div>
              <div class="pr-2 input-group">
                <input type="text"
                       v-model="file.text"
                       maxlength="500"
                       class="input_forms px-50 form-control"
                       :placeholder="['application/pdf'].includes(file.mimetype) ? getTranslations('expression_1203') : getTranslations('expression_343')"
                       style="height: 2.5rem;">
              </div>
              <div style="display: flex;justify-content: flex-end;width: 100%; position: relative;">
                <TextCount :length="file.text ? file.text.length : 0" limit="500"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="px-2 py-2 d-flex">
      <div v-if="!send_message_loading" @click.prevent="sendFiles" class="d-flex justify-center align-items-center shadow-sm cursor_pointer animated--grow-in btn-primary py-2 px-3">
        <i class="animated--grow-in bx bxs-send hover_icons"></i>
        <span class="text-white ml-2">{{ getTranslations('expression_562') }}</span>
      </div>
      <div v-else class="d-flex justify-center align-items-center shadow-sm cursor_pointer animated--grow-in btn-primary py-2 px-3">
        <v-progress-circular :width="3" :size="20" indeterminate color="primary"></v-progress-circular>
        <span class="text-white ml-2">{{ getTranslations('expression_36') }}</span>
      </div>
    </div>
  </ModalDefault>
</template>

<script>
import ModalDefault from "../../components/general/ModalDefault";
import {mapGetters, mapState} from "vuex";
import $ from "jquery";
import Swal from "sweetalert2";
import TextCount from "../general/TextCount";

export default {
  name: "ModalChatFilesTicket",
   components: {
     TextCount,
     ModalDefault,
   },
  computed: {
    ...mapState(['chat', 'me', 'operators']),
    ...mapGetters([
      'getChannelObject',
    ])
  },
  data(){
    return {
      send_message_loading: false
    }
  },
  mounted() {
    this.$root.$on('clearFiles',()=> {
      this.chat.files = [];
    })
    this.$root.$on('sendFiles',(files)=> {
      this.callFiles(files);
    });

    $('#filesTicketModal').on('hidden.bs.modal', () => {
      this.$root.$emit('clearFiles')
    })
  },
  methods: {
    isOperator(department_id) {
      if (department_id === null) {
        department_id = this.getChannelObject('id', this.chat.ticket.channel_id).parameter.department_id
      }
      let operator = this.operators.data.find(operator => {
        return operator.department_id === department_id && operator.user_id === this.me.data.id;
      });
      if (operator !== undefined) {
        return operator.id
      } else {
        return null
      }
    },
    loadFile(){
      const files = document.getElementById('fileHandlerChat')
      this.callFiles(files.files);
      files.value = ''
    },
    callFiles(files) {
      const totalFile = files.length + this.chat.files.length;
      if(files && totalFile > 0 && totalFile < 4){
        files.forEach(file => {
          if([
            'image/png',
            'image/jpeg',
            'image/jpg',
            'image/webp',
            'application/pdf',
            'video/mpeg',
            'video/mp4',
            'audio/mpeg',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/msword',
            'application/vnd.ms-excel',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          ].includes(file.type)){
            const size = (file.size / 1024) / 1024
            // limite de MB de envio
            if (size <= 16){
              const FR = new FileReader();
              FR.addEventListener('load', (e) => {
                this.chat.files.push({
                  file: e.target.result,
                  mimetype: file.type,
                  filename: file.name,
                  text: '',
                  channel_id: this.chat.ticket.channel_id,
                  ticket_id: this.chat.ticket.id,
                  operator_id: this.isOperator(this.chat.ticket.department_id),
                  department_id: this.chat.ticket.department_id,
                })
              })
              FR.readAsDataURL(file)
            } else {
              Swal.fire(
                `${ this.getTranslations('expression_683') }`,
                `${this.getTranslations('expression_681').replace('{size}', '15MB')}
                      <br/>
                      <small>${this.getTranslations('expression_682')} ${file.name}</small>`,
                'warning'
              )
            }
          } else {
            Swal.fire(
              `${ this.getTranslations('expression_683') }`,
              `${ this.getTranslations('expression_684') } <br/> <small>${ this.getTranslations('expression_705') }</small> <br/> <small>${this.getTranslations('expression_682')} ${file.name}</small>`,
              'warning'
            )
          }
        })
      } else {
        Swal.fire(
          `${ this.getTranslations('expression_683') }`,
          `${ this.getTranslations('expression_897') }`,
          'warning'
        )
      }
    },
    sendFiles() {
      this.send_message_loading = true
      this.chat.ui.row_textarea = 1
      this.chat.files.forEach(file => {
        this.$store.dispatch('sendMessage', file)
      })
      this.chat.text = "";
      this.chat.isShowEmoji = false;
      setTimeout(() => {
        this.send_message_loading = false
        $('#filesTicketModal').modal('hide')
      }, 700)


      // setTimeout(() => {
      //   this.$root.$emit('chatTextareaFocus')
      // }, 200)
    },
  }
}
</script>

<style scoped>
  #fileHandlerChat {
    opacity: 0;
    width: 100%;
    height: 200px !important;
    position: absolute;
    cursor: pointer;
    left: 0;
  }
</style>
